import React from 'react';
import { cn } from '../../../lib/utils';

interface RippleProps {
  mainCircleSize?: number;
  mainCircleOpacity?: number;
  numCircles?: number;
  className?: string;
}

export const Ripple: React.FC<RippleProps> = ({
  mainCircleSize = 210,
  mainCircleOpacity = 0.2,
  numCircles = 6,
  className,
}) => {
  return (
    <div className={cn('pointer-events-none absolute inset-0 select-none', className)}>
      {Array.from({ length: numCircles }).map((_, i) => {
        const size = mainCircleSize + i * 70;
        const opacity = Math.max(mainCircleOpacity - i * 0.03, 0.02);
        return (
          <div
            key={i}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#003b82]/40 bg-[#003b82]/[0.015] animate-ripple"
            style={{
              width: size,
              height: size,
              opacity,
              animationDelay: `${i * 0.06}s`,
            }}
          />
        );
      })}
    </div>
  );
};
